import ConditionalWrapper from "./ConditionalWrapper";

const GenerateClassName = (value, log) => {

    // this.handleCssName = (value, log) => {
    const umlauts = { ä: "ae", ü: "ue", ö: "oe", á: "a", é: "e", ó: "o", ő: "o" };
    let cssName = "";
    if (typeof value === "string") {
        cssName = value
            .toString()
            .toLowerCase()
            .trim()
            .replace(/\s/g, "")
            .replace(/\|/g, "-")
            .replace(/\,/g, "-")
            .replace(/\)/g, "")
            .replace(/&/g, "-")
            .replace(/\(/g, "")
            .replace(/\./g, "-")
            .replace(/\//g, "-")
            .replace(/[äöüßáéóő]/g, function ($0) {
                return umlauts[$0];
            });
    }

    if (cssName[cssName.length - 1] == "-") {
        cssName = cssName.slice(0, -1);
    }
    return cssName;
};

export default GenerateClassName;
